import { render } from "./ListsCustomers.vue?vue&type=template&id=d751eaea&scoped=true"
import script from "./ListsCustomers.vue?vue&type=script&lang=ts"
export * from "./ListsCustomers.vue?vue&type=script&lang=ts"

import "./ListsCustomers.vue?vue&type=style&index=0&id=d751eaea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d751eaea"

export default script